module.exports = __webpack_public_path__ + "static/media/racivid1.fac55573.png";